var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "details" },
    [
      _vm._m(0),
      _c("Table", {
        attrs: {
          items: _vm.contacts,
          attributes: _vm.tableAttributes,
          options: _vm.tableOptions
        },
        on: { edit: _vm.editPhone, head: _vm.addPhone }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "intro" }, [
      _c("h4", [_vm._v("Phone Numbers")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }